import { composeDecorators } from '@draft-js-plugins/editor';

import createImagePlugin from '@draft-js-plugins/image';

import { blockDndPlugin } from '../move-block/move-block';
import { focusPlugin } from '../focus/focus';
import { resizeablePlugin } from '../resizeable/resizable';
import { alignmentPlugin } from '../alignment/alignment';

const decorator = composeDecorators(
    resizeablePlugin.decorator,
    alignmentPlugin.decorator,
    focusPlugin.decorator,
    blockDndPlugin.decorator
);
export const imagePlugin = createImagePlugin({ decorator });
